import { Head } from "@inertiajs/react";
import pageTitle from "../../utils/pageTitle";

export default function () {
  return (
    <>
      <Head title={pageTitle('Условия использования файлов cookie')} />
      <div className="container mx-auto lg:px-4 py-16 px-8 md:px-0">
        <div className="prose prose-lg max-w-none">
          <h1>Условия использования файлов cookie</h1>
          Мы используем файлы cookie и храним данные пользователей в соответствии
          с Политикой обработки персональных данных. Посещая сайт, вы соглашаетесь
          с обработкой cookies.
          <h2>Что такое cookies</h2>
          <p>
            Это файлы, которые браузер хранит на вашем устройстве. Они содержат
            логин и пароль, историю посещений и другую информацию о вас. Также
            cookies обеспечивают стабильную работу сайтов и запоминают ваш выбор —
            например, город, в котором вы находитесь, или языковые настройки.
          </p>
          <h2>Как управлять cookies</h2>
          <p>
            Вы можете настроить использование файлов cookie. Для этого перейдите в
            настройки браузера и выберите подходящий вариант: разрешить или
            блокировать cookies.
          </p>
        </div>
      </div>
    </>
  );
}
